
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h16v16H0z"}}),_c('g',{attrs:{"fill":"#AB98C3","transform":"translate(.5 1.5)"}},[_c('path',{attrs:{"fill-rule":"nonzero","d":"M6.602 2.044c-3.086.47-5.461 3.293-5.461 6.715h12.735c0-3.422-2.375-6.245-5.462-6.715-.046-.494-1.766-.494-1.812 0zm7.683 8.089H.732c-.155.043-.232.137-.232.283 0 .395.3.716.672.716h12.673c.374 0 .676-.322.676-.716 0-.146-.078-.24-.236-.283z"}}),_c('path',{attrs:{"fill-rule":"nonzero","stroke":"#593289","stroke-width":".5","d":"M7.582 3.647c-2.22 0-4.164 1.68-4.623 3.993a.203.203 0 01-.198.17c-.015 0-.028 0-.043-.005-.11-.025-.179-.14-.155-.257.498-2.513 2.61-4.335 5.022-4.335.508 0 .466.434-.003.434z"}}),_c('circle',{attrs:{"cx":"7.5","cy":"1.5","r":"1.5"}})])])])
          )
        }
      }
    